<script setup>
import { getFieldError } from 'vue3-form'
import { inject, ref } from 'vue'
import { useVModel } from '#/general/useVModel'
import AppInput from '#/general/AppInput'
import { useValidations } from '#/general/useValidations'
import AppPhone from '#/general/AppPhone.vue'
const { components, application, screen, global } = inject('Shared')
const { required } = useValidations()
const props = defineProps([
  'options',
  'form',
  'multiple'
])
defineEmits(['update:value', 'clicked'])
const form = useVModel(props, 'form')
function clicked (option) {
  if (!props.multiple) {
    form.value.fields[option.propertyName].value = option.value
  } else {
    if (form.value.fields[option.propertyName].value.includes(option.value)) {
      form.value.fields[option.propertyName].value = form.value.fields[option.propertyName].value.filter(e => e !== option.value)
    } else {
      form.value.fields[option.propertyName].value.push(option.value)
    }
  }
}
const hovered = ref()
</script>

<template lang="pug">
.selectableFieldsContainer
  template(v-for="(option, index) in options" :key="index")
    template(v-if="['CHECKBOX', 'HIDDEN_TEXT_FIELD'].includes(option.type)")
      .selectableField(
        :class="(hovered === option.value || form.fields[option.propertyName].value === option.value) ? 'hovered' : ''"
        @click="clicked(option)"
        @mouseover="hovered = option.value"
        @mousedown="hovered = null"
      )
        .checkbox(:class="(multiple ? form.fields[option.propertyName].value.includes(option.value) : form.fields[option.propertyName].value === option.value) ? 'checkboxSelected' : ''")
          div(v-if="(multiple ? form.fields[option.propertyName].value.includes(option.value) : form.fields[option.propertyName].value === option.value)")
            svg(width='15' height='11' viewBox='0 0 15 11' fill='none' xmlns='http://www.w3.org/2000/svg')
              path(d='M4.76691 8.6786L1.21092 5.25802L0 6.41462L4.76691 11L15 1.1566L13.7976 0L4.76691 8.6786Z' fill='#626C85')
        .label {{ option.label }}
      app-input(
        v-if="option.type === 'HIDDEN_TEXT_FIELD' && form.fields[option.propertyName].value.includes(option.value)"
        :hide-separator="false"
        separator-color="#5C5C73"
        height="45px"
        v-model:value="form.fields[option.valueName].value"
        @input="getFieldError(form.fields[option.propertyName])"
        color="#9D9DD4"
        input-padding="0 0 5px"
        size="16px"
        :placeholder="option.inputLabel"
        :name="option.name"
        :errors="form.fields[option.propertyName].errors"
      )
    app-input.textInputField(
      v-else-if="option.type === 'INPUT'"
      :hide-separator="false"
      separator-color="#5C5C73"
      input-padding="0 0 5px"
      height="45px"
      v-model:value="form.fields[option.propertyName].value"
      :errors="form.fields[option.propertyName].errors"
      :name="option.name"
      color="#9D9DD4"
      @input="getFieldError(form.fields[option.propertyName])"
      size="16px"
      :type="option.inputType"
      :placeholder="option.label"
    )
    app-phone.textInputField(
      v-else-if="option.type === 'PHONE'"
      :hide-separator="false"
      separator-color="#5C5C73"
      input-padding="0 0 5px"
      height="45px"
      v-model:phone-number="form.fields[option.propertyName].value"
      :errors="form.fields[option.propertyName].errors"
      :name="option.name"
      color="#9D9DD4"
      @input="getFieldError(form.fields[option.propertyName])"
      size="16px"
      :type="option.inputType"
      :placeholder="option.label"
    )
</template>

<style scoped lang="sass">
.selectableFieldsContainer
  padding: 10px 0
  .textInputField
    margin-bottom: 10px
  .selectableField
    width: 100%
    border: 2px solid #9D9DD5
    border-radius: 7px
    margin-bottom: 15px
    display: flex
    align-content: center
    flex-direction: row
    transition: background-color 0.3s ease
    @media screen and (min-width: 1024px)
      padding: 20px
    @media screen and (max-width: 1023px)
      padding: 13px
    &:hover
      cursor: pointer
    .checkbox
      border: 1.5px solid #626C85
      border-radius: 5px
      width: 24px
      height: 24px
      display: flex
      justify-content: center
      align-self: center
      min-width: 24px
    .checkboxSelected
      background: #70FFD0 !important
    .label
      display: flex
      align-items: center
      font-weight: 500
      line-height: 130%
      color: #FFFFFF
      @media screen and (min-width: 1024px)
        font-size: 16px
        margin-left: 18px
      @media screen and (max-width: 1023px)
        font-size: 14px
        margin-left: 11px
  .hovered
    background: #3E485A
    border: 2px solid #5FEFC0 !important
  .selected
    border: 2px solid #5FEFC0 !important
    background: #3E485A !important
    cursor: pointer
</style>
